import { cn } from "@wags/ui/ui-utils";
import { VercelImage } from "@wags/ui/vercel-image.tsx";

export function ClickableStaticMap({
    staticMapSrc,
    alt,
    coordinates,
    className,
}: {
    staticMapSrc: string;
    alt: string;
    coordinates: { lat: number; lng: number };
    className?: string;
}) {
    return (
        <a
            href={`https://maps.google.com/maps?q=${coordinates.lat},${coordinates.lng}`}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
                "img-inset block overflow-hidden rounded-card",
                className,
            )}
        >
            <VercelImage
                src={staticMapSrc}
                alt={alt}
                width={600}
                height={300}
                className="w-full h-full object-cover"
            />
        </a>
    );
}
